export default {
  view: 'core.view_company',
  add: 'core.add_company',
  change: 'core.change_company',
  delete: 'core.delete_company',
  import: 'core.import_company',
  export: 'core.export_company',
};
